import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Table } from '@/components';
import { useSortableData } from '@/hooks';
import { useDepartments, useDepartmentsPagination } from '../hooks';
import { departmentsTableColumns } from '../config';
import { DepartmentsFilter, DepartmentApi } from '../models';
import { Edit as EditIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';

interface DepartmentsTableProps {
  filter: DepartmentsFilter;
}

const DepartmentsTable = ({ filter }: DepartmentsTableProps) => {
  const navigate = useNavigate();
  const columns = useMemo(() => departmentsTableColumns, []);

  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    useDepartmentsPagination();

  const { departments, isDepartmentsLoading, totalItems, totalPages } =
    useDepartments({
      filters: filter,
      paginated: {
        page: currentPage,
        pageSize: pageSize,
      },
    });

  const { sortedData, selectedSort, handleSort } = useSortableData({
    data: departments,
    currentPage: currentPage,
  });

  const renderActions = (rowData: DepartmentApi) => (
    <IconButton
      onClick={() =>
        navigate(`/inventory/geography/departments/edit/${rowData.id}`)
      }
    >
      <EditIcon />
    </IconButton>
  );

  return (
    <div className='w-full p-5 flex flex-col bg-white rounded shadow-sm gap-5'>
      {departments?.length > 0 ? (
        <Table
          columns={columns}
          data={sortedData}
          selectedSort={selectedSort}
          handleSort={handleSort}
          renderActions={renderActions}
          isLoading={isDepartmentsLoading}
          pagination={{
            totalItems,
            totalPages,
            currentPage,
            rowsPerPage: pageSize,
            onPageChange: handlePageChange,
            onRowsPerPageChange: handlePageSizeChange,
          }}
        />
      ) : (
        'No hay registros por el momento'
      )}
    </div>
  );
};

export default DepartmentsTable;
